import * as colors from "src/styles/constants/colors";
import * as spacing from "src/styles/constants/spacing";
import * as radius from "src/styles/constants/radius";
import * as typography from "src/styles/constants/typography";

import { StyledProps } from "src/ts-types";
import styled, { css } from "styled-components";

export type DisplayProps = {
  isText?: boolean;
  isMandatory?: boolean;
  isCheckbox?: boolean;
  disabled?: boolean;
  clickToEdit?: boolean;
  "data-cy"?: string;
} & StyledProps;

export type DisplayContainerProps = {
  isText?: boolean;
  isCheckbox?: boolean;
  disabled?: boolean;
  locked?: boolean;
  noBottomMargin?: boolean;
};

// Duplicate from src/
export const DisplayContainer = styled.div<DisplayContainerProps>`
  display: flex;
  width: 100%;
  ${({ isText, isCheckbox }) =>
    isText
      ? css`
          min-height: ${spacing.space_xl};
        `
      : css`
          height: ${isCheckbox ? "32px" : spacing.space_xl};
        `}
  align-items: center;
  margin-bottom: ${(props) => (props.noBottomMargin ? 0 : spacing.space_m)};

  cursor: ${(props) =>
    props.disabled ? "not-allowed" : props.isCheckbox ? "pointer" : "initial"};
  pointer-events: ${(props) => (props.disabled ? "none" : "all")};

  > div > div {
    display: none;
  }

  :hover {
    > div > div {
      display: ${(props) => (props.locked ? "none" : "block")};
    }
  }
`;

export const Display = styled.div<DisplayProps>`
  position: relative;
  flex: 1;
  border: ${(props) =>
    props.isMandatory
      ? `1px solid ${colors.redDark}`
      : props.isCheckbox
        ? "none"
        : `1px solid ${colors.grey2}`};
  border-radius: ${radius.small};
  padding: ${(props) => (props.isCheckbox ? "0" : "0.15em 0.6em")};
  font-size: 0.88rem;
  font-weight: ${typography.normal};
  line-height: 24px;
  height: 100%;
  cursor: ${(props) =>
    props.disabled ? "not-allowed" : props.clickToEdit ? "pointer" : "initial"};
  word-break: break-word;
  ${({ isText }) =>
    isText
      ? css`
          white-space: pre-wrap;
        `
      : css`
          > span {
            max-width: 240px;
            overflow-x: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 1.95em;
            display: flex;
            align-items: center;
          }
        `}
`;
